import { graphql, useFragment } from 'react-relay';

import { type useRenderBlurbs_displayInfo$key } from './__generated__/useRenderBlurbs_displayInfo.graphql.ts';

const displayInfoFragment = graphql`
    fragment useRenderBlurbs_displayInfo on ItemDisplayInfo {
        pricing {
            showSold
            showUnavailable
        }
    }
`;

export const useRenderBlurbs = ({
    displayInfo: displayInfoRef,
}: {
    displayInfo: useRenderBlurbs_displayInfo$key | null | undefined;
}): boolean => {
    const displayInfo = useFragment(displayInfoFragment, displayInfoRef);

    if (!displayInfo) {
        return false;
    }

    const pricingDisplayInfo = displayInfo?.pricing || null;
    const hasValidPricingDisplayInfo = !!pricingDisplayInfo && !pricingDisplayInfo.showUnavailable;

    return hasValidPricingDisplayInfo && !pricingDisplayInfo.showSold;
};
